<script>
import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import StarRating from 'vue-star-rating'
export default {
  name: 'interest-details',
  data () {
    return {
      userid: '',
      base_urls: BaseURL,
      profiledetails: [],
      profilesills: [],
      groupeddate: [],
      pSkils: [],
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      postdatas: [],
      postdetails: [],
      scheduledetail: [],
      sid: [],
      startdate: '',
      enddate: '',
      selectpost: '',
      tabOne: true,
      tabTwo: false,
      validationerror: false,
      rating: 3.5,
      profiledetails1: [],
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      sections:
      [
        { value: 75, color: '#f39c12' }
      ],
      video: {
        sources: [{
          src: '../../assets/video/video.mp4',
          type: 'video/mp4'
        }],
        options: {
          autoplay: true,
          volume: 0.6,
          poster: '../../assets/video/video.mp4'
        }
      }
    }
  },
  components: {
    StarRating
  },
  created () {
    this.shwovalue = true
    this.posts = JSON.parse(localStorage.getItem('postId'))
    this.interviewer = JSON.parse(localStorage.getItem('viewid'))
    this.userid = JSON.parse(localStorage.getItem('viewid'))
    this.selectpost = JSON.parse(localStorage.getItem('postId'))
    this.startdate = ''
    this.enddate = ''
    this.getdata()
    this.getpostdata()
    this.getdetails()
  },
  methods: {
    close () {
      this.$emit('input', !this.shwovalue)
    },
    getdetails () {
      console.log('select')
      let postdatas = []
      postdatas = {
        org_id: this.userInfo._id,
        post_id: this.selectpost,
        user_id: this.interviewer
      }
      const mainurl = '/dashboard/get_post_interested_detail_web'
      axios.post(`${this.base_urls}${mainurl}`, { formData: postdatas }, this.config).then(response => {
        console.log(response.data)
        this.profiledetails = response.data.postInterestedDetails[0]
      }).catch(e => {
        console.log(e)
      })
    },
    getdata () {
      const mainurl = '/dashboard/get_profile_detail/' + this.userid + '/' + this.selectpost + '/' + this.userInfo._id
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.profiledetails1 = response.data.profileDetail[0]
        // this.profilesills = response.data.profileSkillList
      }).catch(e => {
        console.log(e)
      })
    },
    getpostdata () {
      this.userInfo = JSON.parse(localStorage.getItem('user__details'))
      const mainurl = '/dashboard/get_post_details/ios/' + this.selectpost + '/' + this.userInfo._id
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.postdetails = response.data.interviewerList[0]
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<template>
<!-- <div class="custom-modal-backdrop" v-show="shwovalue">  -->
  <div class="modal fade in" id="modal-default" style="display: block;" v-show="shwovalue">
  <div class="modal-dialog" style="margin-top:15px">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" aria-label="Close">
          <span aria-hidden="true" @click="close()">×</span></button>
        <h4>Interested</h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-4">
            <div >
              <div class="direct-chat-info clearfix">
                <span class="direct-chat-name pull-left">
                  <span style="color:#999;font-weight: 400;font-size:12px">Job Title</span>
                  <span><h5 class="mt-0 mb-7 c-g">{{postdetails.job_tittle}}</h5></span><br>
                  <span class="skill-title">Skillset</span><br>
                  <span class="skill-value mb-2">{{postdetails.primaryskillnames}}</span><br>
                  <span class="skill-title">Interview Type</span><br>
                  <span class="skill-value">{{postdetails.job_interview_type}}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-8 pull-right gray-details p-1">
            <div class="direct-chat-messages">
              <b>Interviewer</b>
              <hr>
              <div class="direct-chat-msg">
                <img @click="showModal(profiledetails._id)" v-if="profiledetails.profile_picture !='' && profiledetails.profile_picture !=null" :src="`${profiledetails.profile_picture}`" class="direct-chat-img">
                              <img @click="showModal(profiledetails._id)" v-if="profiledetails.profile_picture =='' || profiledetails.profile_picture ==null && profiledetails.gender == null" src="../../assets/img/default.png" class="direct-chat-img">
                              <img @click="showModal(profiledetails._id)" v-if="profiledetails.profile_picture =='' || profiledetails.profile_picture ==null && profiledetails.gender == 'female'" src="../../assets/img/female_default.png" class="direct-chat-img">
                              <img @click="showModal(profiledetails._id)" v-if="profiledetails.profile_picture =='' || profiledetails.profile_picture ==null && profiledetails.gender == 'male'" src="../../assets/img/male_default.png" class="direct-chat-img">
                <div class="direct-chat-info clearfix">
                  <span class="direct-chat-name pull-left ml-5">{{profiledetails.first_name}} {{profiledetails.last_name}}</span><br>
                    <span style="color:#999;font-weight: 400;" class="ml-5">Skillset : {{profiledetails.userskillnames}}
                    </span>
                  <span class="direct-chat-timestamp pull-right" style="width:25%"><star-rating class="pull-right" :show-rating="false" style="width:75%" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="15" :rating="profiledetails1.interviewer_rating" read-only="true"></star-rating></span>
                </div>
                <div class="direct-chat-info clearfix  mt-5">
                  <div>
                    <button class="btn btn-default btn-xs btns pull-left">Experience : 6 Years | <i class="uil uil-rupee-sign"></i>{{profiledetails1.interview_cost}} / Interview</button>
                    <div v-if="profiledetails.start_time != null">
                    <a style="line-height: 2;" class="button btn-align sbtn btn-sm accent-btn rounded raised pull-right"><i class="fa fa-clock-o" aria-hidden="true"></i> {{profiledetails.start_time}} to {{profiledetails.end_time}}</a>
                      <div class="pull-right with-date" style="width: 16%;">
                      <span>{{profiledetails1.start_datetime | formatDate}}</span><br>
                      <span>{{profiledetails1.start_datetime | getDay}}</span>
                    </div>
                    </div>
                    <!-- <span class="direct-chat-timestamp pull-right ml-1 wishlist mt-6" style="width: 15%;"><a><i class="fa fa-clock" aria-hidden="true"></i> Reshedule</a></span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <hr v-if="profiledetails.reason_name != null && profiledetails.reason_name != ''">
          <div class="col-md-11" style="left: 4%;" v-if="profiledetails.reason_name != null && profiledetails.reason_name != ''">
            <div class="direct-chat-info clearfix">
              <h5 v-if="profiledetails.statusval == 'Cancelled' || profiledetails.statusval == 'cancelled'" class="pull-left">Reason for Cancellation</h5>
              <h5 v-if="profiledetails.statusval == 'Declined' || profiledetails.statusval == 'declined'" class="pull-left">Reason for Declining</h5>
              <!-- <span class="pull-right" style="margin-top:11px" v-if="profiledetails.statusval == 'Declined'"><span class="text-mute">Cancelled by </span><b>{{profiledetails.first_name}} {{profiledetails.last_name}}</b></span>
              <span class="pull-right" style="margin-top:11px" v-if="profiledetails.statusval == 'Cancelled'"><span class="text-mute">Cancelled by </span><b>{{postdetails.first_name}} {{postdetails.last_name}}</b></span> -->
            </div>
            <hr>
            <p>{{profiledetails.reason_name}}</p>
            <h5>Comments</h5>
            <hr>
            <p>{{profiledetails.comments}}</p>
          </div>
          <div class="col-md-12">
            <hr>
            <div class="form-submit">
              <div>
                <span v-if="profiledetails.statusval == 'Cancelled' || profiledetails.statusval == 'cancelled'" class="direct-chat-timestamp pull-right mt-2 bg-status" style="color:red;margin-right: 10px;"> Cancelled</span>
                <span v-if="profiledetails.statusval == 'Declined' || profiledetails.statusval == 'declined'" class="direct-chat-timestamp pull-right mt-2 bg-status" style="color:red;margin-right: 10px;"> Declined</span>
                <span v-if="profiledetails.status == 'Accepted' || profiledetails.status == 'accepted'" class="direct-chat-timestamp pull-right mt-2" style="color:#5bad2b;margin-right: 10px;"><i class="fa fa-check" aria-hidden="true"></i> Accepted</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
</div>
</template>
<style scoped>
@media screen and (min-width: 769px){
  .modal-content, .modal-card {
      margin: 0 auto;
      width: 801px;
  }
}
.modal { overflow: auto !important; }
.modal-header {
  padding: 8px !important;
}
img {
    max-width: 84px;
    height: auto;
}
.modal-header {
  background-color: #F5F5F5;
  border-bottom: 1px solid #cccccc73;
}
.nav-tabs {
  border-bottom: 0;
  margin-bottom: 0;
  background-color: #f5f5f5;
}
.nav-tabs li {
  width:auto;
}
.nav-tabs li a {
  color:black;
}
.nav-tabs li.active a {
  background-color: #5bad2b;
  color: white;
}
.nav-tabs li.active a:hover {
  background-color: #5bad2b;
  color: white;
}
hr {
    border-top: 1px solid #55555538 !important;
}
hr {
  margin-top: 5px;
  margin-bottom: 5px;
}
.info-box {
  background-color: #f5f5f5 !important;
}
.bg-yellow {
  border-right: 5px solid white;
  background-color: #f5f5f5 !important;
}
.info-box-content {
    padding: 39px 10px;
    margin-left: 90px;
}
.info-box-number {
  font-size: 12px;
}
.resumeview {
  margin-top: 6px;
  margin-right: 20px;
  color: #5bad2b;
}
.f14 {
  font-size: 14px !important;
}
.cg {
  color: #5bad2b;
}
.c {
  text-align: center;
}
tr th {
  text-align: center;
}
.donate-now {
  list-style-type: none;
  margin: 25px 0 0 0;
  padding: 0;
}

.donate-now li {
  float: left;
  margin: 0 5px 0 0;
  width: 112px;
  height: 52px;
  position: relative;
}

.donate-now input[type="radio"]:checked+label,
.Checked+label {
  background: #5bad2b;
  color:#fff;
}

.donate-now label {
  padding: 5px;
  border: 1px solid #CCC;
  cursor: pointer;
  z-index: 90;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.donate-now label:hover {
  background: #DDD;
}
.table>tbody>tr>td {
  padding: 4px;
}
.direct-chat-name.nametext {
  font-size: 14px;
  font-weight: 400;
}
.box-default {
  border: 1px solid #cccccc6e;
}
.box-header.chart {
  background-color: #f5f5f5;
  border: 1px solid #cccccc6e;
}

.button {
  cursor: pointer;
}
.gray-details .direct-chat-messages {
  background-color: #f5f5f5;
  border: 1px solid #cccccc8f;
  overflow: hidden;
  min-height: 130px;
  height: auto;
}
.ml-2 {
  margin-left: 10px;
}
.mt-2 {
    margin-top: 2px !important;
}
.mr-4 {
    margin-right: 4px !important;
}
.mt-4 {
    margin-top: 4px !important;
}
.mt-6 {
    margin-top: 6px !important;
}
.mt-5 {
    margin-top: 5px !important;
}
.mt-0 {
  margin-top: 0px;
}
.mb-7 {
  margin-bottom: -7px !important;
}
.skill-title {
  color: rgb(153, 153, 153);
  font-weight: 400;
  font-size: 12px;
}
.skill-value {
  color: #333;
  font-weight: 400;
  font-size: 14px;
}
.direct-chat-msg {
    margin-bottom: 0px;
}
.text-g {
  color: #a29d9d;
}
.text-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 2px;
  display: block;
  color: #5B5B5B;
}
.bg-status {
  padding: 4px;
  background-color: #f5f5f5;
}
</style>
